import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

interface LoadingProps {
  message?: string;
  className?: string;
  iconClassName?: string;
  /**
   * - `inline`: junto a otro contenido (dentro de un botón, un renglón).
   * - `block`: ocupa su contenedor y se centra.
   */
  variant?: "inline" | "block";
  showSubtext?: boolean;
}

/**
 * Indicador de carga.
 *
 * Para listas y tablas prefiere `TableSkeleton`/`CardGridSkeleton`: reservan la
 * forma final y evitan el salto de contenido. Este spinner es para esperas
 * cortas y sin forma conocida (enviar un formulario, resolver una sesión).
 */
export function Loading({
  message = "Cargando datos",
  className = "",
  iconClassName,
  variant = "block",
  showSubtext = false,
}: LoadingProps) {
  if (variant === "inline") {
    return (
      <div
        role="status"
        aria-live="polite"
        className={cn("flex items-center gap-2 text-sm text-muted-foreground", className)}
      >
        <Loader2 className={cn("h-4 w-4 shrink-0 animate-spin", iconClassName)} />
        {message && <span className="truncate">{message}</span>}
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "flex animate-fade-in flex-col items-center justify-center px-4 py-10 text-center",
        className
      )}
    >
      <Loader2
        className={cn("h-6 w-6 animate-spin text-primary", iconClassName)}
        aria-hidden="true"
      />
      {message && (
        <p className="mt-3 text-sm font-medium text-foreground">{message}</p>
      )}
      {showSubtext && (
        <p className="mt-1 text-xs text-muted-foreground">
          Esto puede tardar unos segundos.
        </p>
      )}
    </div>
  );
}
